export default "__VITE_ASSET__FMG94URR__"